import {
  AgentEndpoints,
  type CommonResponse,
  RequestMethods,
  useRequest,
} from '@src/shared';

export const useGetContractDraft = () => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    unknown,
    BlobPart,
    CommonResponse
  >({
    params: {
      key: 'getAgentContractDraft',
      method: RequestMethods.GET,
      url: `${AgentEndpoints.AGENTS}/contracts/draft`,
      fetchManual: true,
    },
    config: { responseType: 'blob' },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
